import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from "@app/models/util/paginacao";

import { Unidade } from '@app/models/unidade.model';
import { UnidadeService } from '@app/services/unidade.service';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-unidade-lista',
  templateUrl: './unidade-lista.component.html'
})
export class UnidadeListaComponent implements OnInit {

  bsModalRef: BsModalRef;
  filtroDescricao: string = "";
  lstUnidades: Unidade[];
  paginacao: Paginacao = new Paginacao();

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private unidadeService: UnidadeService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
    //  this.obterUnidadeMatriz();
  }


  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.unidadeService.obterLista(descricao, pagina).toPromise().then(
      data => {
        this.lstUnidades = data.Dados,
          this.paginacao.totalDeItens = data.Total
      },
      erro => {
        //this.loading = false;
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }

  // obterUnidadeMatriz() {
  //   this.unidadeService.obterUnidadeMatriz()
  //     .subscribe(data => {
  //       if (data != null && data!= undefined)
  //         this.unidadeMatriz = data;
  //       }
  //     );
  // }


  deletar(unidade: Unidade) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente excluir a unidade: " + unidade.Descricao + "?";
    this.bsModalRef.content.confirmar = () => {
      this.unidadeService.deletar(unidade.Id).toPromise().then(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    }
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }
}
